export const LIST_PROJECT_KEY = ["OP", "AL", "E0", "PD", "M0U"];
export const DEFAULT_QUARTER_KEY = "CaR Q";
